import { HttpClient } from 'src/clients';

class LogoService {
  static getLogoDetails(logoId) {
    return HttpClient.get(`/logo/${logoId}/details`);
  }
}

export { LogoService };
